import { DateCalculator } from './../../../models/dateCalculator';
import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompanyRef, ScheduleDate, PayrollParameters, PeriodTypeEnum, Employee, LoanParameters } from '@akiba/models_bimbo';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTable, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { AppState } from '../../../models/appState';
import { LogicService } from '../../../services/logic.service';
import * as moment from 'moment';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PayrollComponent implements OnInit, OnDestroy {

  @ViewChild('payrollDatesTable', { static: false }) payrollDatesTable: MatTable<ScheduleDate>;
  @ViewChild('companiesTable', { static: false }) companiesTable: MatTable<CompanyRef>;

  wageTypes = [{ type: 2, typeString: 'PR' }, { type: 3, typeString: 'QU' }, { type: 2, typeString: 'VE' }];
  days = [{ dateDay: 1, dateString: 'Lunes' }, { dateDay: 2, dateString: 'Martes' }, { dateDay: 3, dateString: 'Miércoles' }, { dateDay: 4, dateString: 'Jueves' }, { dateDay: 5, dateString: 'Viernes' }, { dateDay: 6, dateString: 'Sábado' }, { dateDay: 7, dateString: 'Domingo' }];
  displayedLoanDatesColumns: string[] = ['Start', 'day', 'active', 'delete'];
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];

  selectionCompaniesSubscription: Subscription = null;
  //////////////////////////////////////
  selectionCompanies: SelectionModel<CompanyRef>;
  permanentLoanParameter: LoanParameters | null = null;
  //////////////////////////////////////

  generalSubscription: Subscription = null;
  startDate = new ScheduleDate();
  newPayrollDate = new ScheduleDate();
  dc = new DateCalculator();
  companies: Array<CompanyRef> = new Array<CompanyRef>();
  @Input() isEdit: boolean;
  @Input() wageType: any;
  @Input() modPayrollParameter: PayrollParameters;
  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog) {
    this.selectionCompanies = new SelectionModel<CompanyRef>(true, []);

    this.generalSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(p => {

      if (p && p.response) {

        this.companies = this.logicService.dataManager.generalDataLoader.companies;
      }

    });

    this.logicService.dataManager.generalDataLoader.load();

  }

  ngOnInit() {

    if (this.modPayrollParameter) {

      if (this.displayedLoanDatesColumns.length === 5) {
        this.displayedLoanDatesColumns.splice(2, 1);
      }

      if (this.modPayrollParameter.payrollType) {

        const wType = this.wageTypes.find(e => e.typeString === String(this.modPayrollParameter.payrollType));

        if (wType && wType.type === 2) {
          this.displayedLoanDatesColumns.splice(2, 0, 'Week');
        } else {
          this.displayedLoanDatesColumns.splice(2, 0, 'BiWeek');
        }

      }

      this.startDate.startDate = null;
      this.newPayrollDate.startDate = null;

    }

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    this.selectionCompaniesSubscription = this.selectionCompanies.changed.subscribe(x => {

      if (x.added.length) {

        x.added.forEach(element => {
          const index = this.modPayrollParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          if (index < 0) {
            this.modPayrollParameter.includedCompanies.push(element);
          }
        });

      } else if (x.removed.length) {

        x.removed.forEach(element => {
          const index = this.modPayrollParameter.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
          this.modPayrollParameter.includedCompanies.splice(index, 1);

        });

      }

    });

    if (this.companiesTable) {
      this.companiesTable.renderRows();
    }

    if (this.payrollDatesTable) {
      this.payrollDatesTable.renderRows();
    }

  }

  changeCompanies(event, row: any) {

    if (event.checked === true) {
      const index = this.modPayrollParameter.includedCompanies.findIndex(ic => ic.companyID === row.companyID);
      const newCompany = row.toAny();

      if (index < 0) {
        this.modPayrollParameter.includedCompanies.push(newCompany);
      }

    } else if (event.checked === false) {

      const index = this.modPayrollParameter.includedCompanies.findIndex(ic => ic.companyID === row.companyID);
      this.modPayrollParameter.includedCompanies.splice(index, 1);
    }
  }

  switchTo(anIndex: number) {
    this.selectionCompanies = new SelectionModel<CompanyRef>(true, []);
    this.contentLocation.savingParametersIndex = anIndex;

    if (anIndex === 1) {

      if (this.logicService.dataManager.generalDataLoader.companies.length) {
        this.logicService.dataManager.generalDataLoader.companies.forEach(cr => {
          const index = this.modPayrollParameter.includedCompanies.map(ic => ic.companyID).indexOf(cr.companyID);
          if (index >= 0) {
            this.selectionCompanies.select(cr);
          }
        });
      }

    }
  }

  scheduleDay(day: number): string {
    const d = this.days.find(element => element.dateDay === day);
    if (d !== undefined) {
      return d.dateString;
    }
    return '';
  }

  setStartDate(event: MatDatepickerInputEvent<moment.Moment>) {

    if (!this.wageType && this.isEdit === false) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El tipo del sueldo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.wageType && this.isEdit) {

      if (this.displayedLoanDatesColumns.length === 5) {
        this.displayedLoanDatesColumns.splice(2, 1);
      }

      if (this.modPayrollParameter.payrollType) {

        const wType = this.wageTypes.find(e => e.typeString === String(this.modPayrollParameter.payrollType));
        if (wType.type === 2) {
          this.displayedLoanDatesColumns.splice(2, 0, 'Week');
        } else {
          this.displayedLoanDatesColumns.splice(2, 0, 'BiWeek');
        }

        this.startDate.startDate = event.value.toDate();

      }

    } else {
      if (this.displayedLoanDatesColumns.length === 5) {
        this.displayedLoanDatesColumns.splice(2, 1);
      }

      if (this.wageType.type === 2) {
        this.displayedLoanDatesColumns.splice(2, 0, 'Week');
      } else {
        this.displayedLoanDatesColumns.splice(2, 0, 'BiWeek');
      }

      this.startDate.startDate = event.value.toDate();
      const result = this.dc.calculateDates(this.startDate.startDate, this.wageType.typeString, this.wageType.type);
      this.modPayrollParameter.payrollDates.splice(0, this.modPayrollParameter.payrollDates.length);
      this.modPayrollParameter.payrollDates = result;

    }


  }

  setExceptionDate(event: MatDatepickerInputEvent<moment.Moment>) {
    this.newPayrollDate.startDate = event.value.toDate();
  }

  addDate() {

    let wType = '';
    if (this.wageType) {
      wType = this.wageType.typeString;
    } else {
      const ft = this.wageTypes.find(e => e.typeString === String(this.modPayrollParameter.payrollType));
      if (ft !== undefined) {
        wType = ft.typeString;
      }
    }

    const aMoment = moment(this.startDate.startDate);
    const pd = new ScheduleDate();
    pd.startDate = aMoment.startOf('day').toDate();
    pd.endDate = aMoment.endOf('day').toDate();
    pd.weekNumber = aMoment.isoWeek();
    const isoWeek = aMoment.isoWeek() / 2;
    pd.biWeekNumber = Math.ceil(isoWeek);
    pd.appliesToWageType = wType;
    pd.active = true;
    pd.scheduleDay = aMoment.isoWeekday();
    this.modPayrollParameter.payrollDates.push(pd);

    this.modPayrollParameter.payrollDates.sort((a, b) => {
      return a.startDate.getTime() - b.startDate.getTime();
    });

    if (this.payrollDatesTable) {
      this.payrollDatesTable.renderRows();
    }

    // this.newPayrollDate.startDate = null;

  }

  deleteLoanDate(index: number) {
    this.modPayrollParameter.payrollDates.splice(index, 1);
    if (this.payrollDatesTable) {
      this.payrollDatesTable.renderRows();
    }
  }


  reset() {
    this.startDate.startDate = null;
    this.newPayrollDate.startDate = null;
  }

  ngOnDestroy(): void {

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
      this.selectionCompaniesSubscription = null;
    }

    if (this.generalSubscription && !this.generalSubscription.closed) {
      this.generalSubscription.unsubscribe();
      this.generalSubscription = null;
    }


  }

}
